import React from 'react'
import { IconButton } from '@material-ui/core'
import IconCloudDownload from '@material-ui/icons/CloudDownload'
import { withStyles, createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from "mui-datatables";
import { cyan } from '@material-ui/core/colors'
import downloadAsExcel from '../resources/downloadAsExcel'

const styles = theme => ({
  icon: {
    width: 32,
    height: 32
  },
  button: {
    margin: theme.spacing.unit,
    width: 64,
    height: 64,
    padding: 16
  }
})

class MonoTextTable extends React.Component {
	columns = (language) => language === 'en' ? [{
      name: 'Sentence ID',
      options: {
        display: false,
        download: true
      }
    }, 'English'] : [{
      name: 'Sentence ID',
      options: {
        display: false
      }
    }, 'Chinese']

	getMuiTheme = () => createMuiTheme({
    overrides: {
      MUIDataTableHeadCell: {
        root: {
          '&:nth-child(1)': {
            width: '50%'
          },
          '&:nth-child(2)': {
            width: '50%'
          }
        }
      }
    }
  })

  render () {
  	const { data, language, classes, filename, disabled } = this.props
		const options = {
		  viewColumns: false,
		  selectableRows: 'none',
		  filter: false,
		  elevation: 0,
		  pagination: false,
		  print: false,
		  download: false,
		  search: false,
		  fixedHeader: false,
		  rowHover: false,
		  // downloadOptions: {filename: 'monolingualtext.txt', separator: '\t'},
		  setRowProps: (row, dataIndex) => {
		  	console.debug(`row=${JSON.stringify(row)}, dataIndex=${dataIndex}`)
		  	if (row[0] === this.props.highlightId) {
		  		return {
		  			style: {
			  			backgroundColor: cyan['100']
			  		}
		  		}
		  	}
		  }
		};
    return (<MuiThemeProvider theme={this.getMuiTheme()}>
      <MUIDataTable
        title={<div>
            Download Monolingual Texts
            <IconButton color="primary" className={classes.button} aria-label="Download as Excel" onClick={()=>
              downloadAsExcel({
                columns: this.columns(language),
                data,
                filename: `monolingual-text-${filename}.xls`
              })} disabled={disabled}>
              <IconCloudDownload className={classes.icon}/>
            </IconButton>
          </div>}
        data={data}
        columns={ this.columns(language) }
        options={options}
      />
    </MuiThemeProvider>)
  }
}

export default withStyles(styles)(MonoTextTable)